function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcTree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M31.856 42.855a1 1 0 0 1-1-1v-10a1 1 0 0 1 1-1H36v-8.57H22.285v8.571h4.143a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-10a1 1 0 0 1-1-1v-10a1 1 0 0 1 1-1h4.142v-8.571H6.857v8.571H11a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1v-10a1 1 0 0 1 1-1h4.143v-9.429A.857.857 0 0 1 6 20.57h14.57v-5.142h1.715v5.142h14.571a.857.857 0 0 1 .857.857v9.428h4.143a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1zM15.714 15.428a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h11.428a2 2 0 0 1 2 2v11.428a2 2 0 0 1-2 2z",
    transform: "translate(2.571 2.427)",
    style: {
      fill: "current"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTree);
export default __webpack_public_path__ + "static/media/ic-tree.fe9e54f3f835e57760567d309566d179.svg";
export { ForwardRef as ReactComponent };